import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomeScreen from './screens/HomeScreen';
import MovieScreen from './screens/MovieScreen';
import NotFound from './screens/NotFound';


// const baseUrl ="https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&page=1";
// const searchApi = "https://api.themoviedb.org/3/search/movie?&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&query=";
function App() {


//   const [movies , setMovies] = useState([]);

//   const [searchTerm , setSearchTerm] = useState('');


//   useEffect(
//     () => {
// fetch(baseUrl)
// .then(res => res.json())
// .then((data) => {
//   console.log(data.results);
//   setMovies(data.results);

// });
//     },[]
//   ); 




  

// const handleSubmit = (e) => {

//   e.preventDefault();

// if(searchTerm){

//   fetch(searchApi + searchTerm)
// .then(res => res.json())
// .then((data) => {
//   setMovies(data.results);
// }
// )

// .catch(err => console.log('error', err));;

// setSearchTerm('');
// }


  

// }


// const handleOnChange = (e) => {

//   setSearchTerm(e.target.value);
// }


  return (

//     <> 


// <header>
//   <form onSubmit={handleSubmit} >

//   <input type="text" 
//           className="search" 
//           placeholder="Search..." 
//           value={searchTerm}
//           onChange={handleOnChange}
//   />

//   </form>
       
//       </header>


//      <div className="movie-container">
      
  
//       {
//         movies.map( (movie) => <Movie key={movie.id} mov={movie}></Movie>
//           )
//       }
  
//       </div>
//     </>
   
    <Router >
      <Switch>
         <Route path="/" component={HomeScreen} exact />
         <Route path="/search/:searchTerm" component={HomeScreen} exact />
         <Route path="/movie/:id" component={MovieScreen} />
         <Route path="*" component={NotFound} />
      </Switch>
    </Router>


  );
}

export default App;
